import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, vModelText as _vModelText, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7bf27669"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "font-semibold text-xl text-gray-800 leading-tight" }, " 問題情報管理 ", -1));
const _hoisted_2 = { class: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "shadow-lg bg-white rounded-lg rounded-b-none p-6" };
const _hoisted_4 = { class: "grid grid-cols-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pr-4 text-right",
    for: "question_id"
}, " 問題ID ", -1));
const _hoisted_6 = {
    id: "question_id",
    class: "col-span-8"
};
const _hoisted_7 = {
    key: 0,
    class: "grid grid-cols-12 mt-4"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "col-span-2 pr-4 text-right" }, " アプリ配信状態 ", -1));
const _hoisted_9 = { class: "col-span-8" };
const _hoisted_10 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "field_ids"
}, " 分野 ", -1));
const _hoisted_12 = { class: "col-span-8 space-y-3" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " 分野1（必須） ", -1));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "分野を選択してください", -1));
const _hoisted_15 = ["value"];
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " 分野2（任意） ", -1));
const _hoisted_17 = ["disabled"];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "未設定", -1));
const _hoisted_19 = ["value"];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " 分野3（任意） ", -1));
const _hoisted_21 = ["disabled"];
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "未設定", -1));
const _hoisted_23 = ["value"];
const _hoisted_24 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 表示写真（問題用） ", -1));
const _hoisted_26 = { class: "col-span-8" };
const _hoisted_27 = {
    key: 0,
    class: "relative w-full md:w-80 mb-3 object-cover"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "question"
}, " 問題文 ", -1));
const _hoisted_32 = { class: "col-span-8" };
const _hoisted_33 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 正答 ", -1));
const _hoisted_35 = { class: "col-span-8" };
const _hoisted_36 = ["for"];
const _hoisted_37 = { class: "col-span-8" };
const _hoisted_38 = ["id", "onUpdate:modelValue"];
const _hoisted_39 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 表示写真（解説用） ", -1));
const _hoisted_41 = { class: "col-span-8" };
const _hoisted_42 = {
    key: 0,
    class: "relative w-full md:w-80 mb-3 object-cover"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "commentary"
}, " 解説 ", -1));
const _hoisted_47 = { class: "col-span-8" };
const _hoisted_48 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "difficulty"
}, " 難易度 ", -1));
const _hoisted_50 = { class: "col-span-8" };
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "0" }, "未設定", -1));
const _hoisted_52 = ["value"];
const _hoisted_53 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " タグ ", -1));
const _hoisted_55 = { class: "col-span-8" };
const _hoisted_56 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-span-2" }, null, -1));
const _hoisted_58 = { class: "col-span-8" };
const _hoisted_59 = { class: "flex justify-end mb-3" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, " 追加済み模試リスト ", -1));
const _hoisted_61 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_62 = { class: "w-full rounded-full py-3 px-4 bg-indigo-200 flex items-center gap-3" };
const _hoisted_63 = { class: "min-w-0 flex-1 truncate" };
const _hoisted_64 = {
    key: 0,
    class: "shrink-0"
};
const _hoisted_65 = ["disabled", "onClick"];
const _hoisted_66 = {
    key: 1,
    class: "pt-5 text-red-500"
};
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, " 保存時に追加する模試 ", -1));
const _hoisted_68 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_69 = { class: "w-full rounded-full py-3 px-4 bg-green-100 flex items-center gap-3" };
const _hoisted_70 = { class: "min-w-0 flex-1 truncate" };
const _hoisted_71 = { class: "shrink-0" };
const _hoisted_72 = {
    key: 1,
    class: "pt-3 text-red-500"
};
const _hoisted_73 = { class: "flex items-center mb-10 justify-end px-4 py-3 bg-gray-50 text-right shadow rounded-b-lg" };
const _hoisted_74 = ["disabled"];
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mr-3 flex-1" }, null, -1));
const _hoisted_76 = ["disabled", "onClick"];
const _hoisted_77 = {
    key: 0,
    class: "flex mt-10 items-center justify-end px-4 py-3 text-right shadow rounded-lg bg-red-100"
};
const _hoisted_78 = ["disabled", "onClick"];
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "h-6 w-6 text-red-500",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        "stroke-width": "2"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "ml-2 text-red-500" }, " 問題の表示写真を削除してもよろしいですか？ ")
], -1));
const _hoisted_80 = { class: "w-full px-4" };
const _hoisted_81 = ["src"];
const _hoisted_82 = /*#__PURE__*/ _createTextVNode(" キャンセル ");
const _hoisted_83 = { class: "flex items-center justify-between gap-3" };
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, " 全て ", -1));
const _hoisted_85 = ["value"];
const _hoisted_86 = { class: "w-full px-4" };
const _hoisted_87 = {
    key: 0,
    class: "text-red-600"
};
const _hoisted_88 = {
    key: 1,
    class: "text-red-600"
};
const _hoisted_89 = { class: "font-medium text-gray-800" };
const _hoisted_90 = { class: "flex flex-wrap mt-2 text-sm text-gray-700" };
const _hoisted_91 = ["checked", "disabled", "name", "onChange"];
const _hoisted_92 = {
    key: 0,
    class: "ml-1 text-xs text-red-500"
};
const _hoisted_93 = { class: "flex items-center justify-end gap-3" };
const _hoisted_94 = /*#__PURE__*/ _createTextVNode(" キャンセル ");
const _hoisted_95 = /*#__PURE__*/ _createTextVNode(" 選択をクリア ");
const _hoisted_96 = ["disabled"];
import { ref, computed, reactive, onMounted, } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { SmartTagz } from 'smart-tagz';
// eslint-disable-next-line import/extensions
import AppLayout from '@/Layouts/AppLayout.vue';
// eslint-disable-next-line import/extensions
import WhiteButton from '../../Common/Button.vue';
// eslint-disable-next-line import/extensions
import InputError from '@/Jetstream/InputError.vue';
import 'smart-tagz/dist/smart-tagz.css';
// eslint-disable-next-line import/extensions
import DialogModal from '../../Common/DialogModal.vue';
// @ts-ignore
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    props: {
        question: {
            type: Object,
            required: false,
            default: () => ({ id: null }),
        },
        subject: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        fields: {
            type: Array,
            required: false,
            default: () => [],
        },
        imagePath: {
            type: String,
            required: false,
            default: null,
        },
        allTags: {
            type: Array,
            required: false,
            default: () => [],
        },
        flash: {
            type: Object,
            default: () => { },
        },
        page: {
            type: String,
            default: '',
        },
        limit: {
            type: String,
            default: '',
        },
        difficulties: {
            type: Array,
            required: false,
            default: () => [],
        },
        examinations: {
            type: Array,
            required: false,
            default: () => [],
        },
        countExaminationQuestions: {
            type: Array,
            required: false,
            default: () => [],
        },
        examinationTypes: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        examinationTypesMaxQuestionCount: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    setup(__props) {
        const props = __props;
        const flashObject = computed(() => ({
            flash: props.flash,
        }));
        const show = ref(false);
        const showAddExaminationModal = ref(false);
        const removingExaminationKey = ref('');
        const selectedExaminationYear = ref('');
        const selectedExaminations = ref([]);
        const modalSelectedExaminations = ref([]);
        const parseExaminationYear = (examination) => {
            const titleMatch = examination.title?.match(/(20\d{2})年度/);
            if (titleMatch) {
                return Number(titleMatch[1]);
            }
            return null;
        };
        const availableExaminationYears = computed(() => {
            const years = props.examinations
                .map((examination) => parseExaminationYear(examination))
                .filter((year) => year !== null);
            return [...new Set(years)].sort((a, b) => b - a);
        });
        const filteredExaminations = computed(() => {
            if (!selectedExaminationYear.value) {
                return props.examinations;
            }
            const year = Number(selectedExaminationYear.value);
            return props.examinations.filter((examination) => parseExaminationYear(examination) === year);
        });
        const form = reactive(Inertia.form({
            id: null,
            _method: 'POST',
            subject_id: null,
            field_name: null,
            field_ids: [null, null, null],
            question: null,
            correct_answer: null,
            dummy_answer1: null,
            dummy_answer2: null,
            dummy_answer3: null,
            dummy_answer4: null,
            commentary: null,
            difficulty: 0,
            tags: props.question.id
                ? props.question.tags.map((tag) => tag.name)
                : [],
            imageQuestion: null,
            imageCommentary: null,
            examinations: [],
            limit: null,
            page: null,
        }));
        // 第2分野で利用可能な選択肢
        const availableFieldsForSecond = computed(() => props.fields.filter((field) => field.id !== form.field_ids[0]));
        // 第3分野で利用可能な選択肢
        const availableFieldsForThird = computed(() => props.fields.filter((field) => field.id !== form.field_ids[0] && field.id !== form.field_ids[1]));
        // 模試種別の定数
        const EXAMINATION_TYPES = {
            REQUIRED: 1,
            GENERAL: 2,
            SPECIAL: 3,
        };
        const examinationTypeText = (type) => {
            switch (type) {
                case EXAMINATION_TYPES.REQUIRED:
                    return '必須';
                case EXAMINATION_TYPES.GENERAL:
                    return '一般';
                case EXAMINATION_TYPES.SPECIAL:
                    return '実地';
                default:
                    return '';
            }
        };
        const selectedExaminationSummaries = computed(() => selectedExaminations.value
            .map((item) => {
            const target = props.examinations.find((examination) => examination.id === item.id);
            if (!target) {
                return null;
            }
            return {
                id: item.id,
                type: item.type,
                title: target.title,
            };
        })
            .filter((item) => item !== null));
        const examinationErrorMessages = computed(() => {
            const errors = form.errors;
            const messages = Object.entries(errors)
                .filter(([key]) => key === 'examinations' || key.startsWith('examinations.'))
                .map(([, message]) => message);
            return [...new Set(messages)];
        });
        const isAddExaminationButtonDisabled = computed(() => (props.question.id ? !modalSelectedExaminations.value.length : false));
        onMounted(() => {
            if (props.question.id) {
                form._method = 'PUT'; // eslint-disable-line no-underscore-dangle
                form.id = props.question.id;
                form.field_name = props.question.field_name;
                // 既存のfieldsリレーションから分野IDを設定
                if (props.question.fields && Array.isArray(props.question.fields)) {
                    const fieldIds = props.question.fields.map((field) => field.id);
                    form.field_ids = [
                        fieldIds[0] || null,
                        fieldIds[1] || null,
                        fieldIds[2] || null,
                    ];
                }
                else if (props.question.field_name) {
                    // 既存データ（field_name）から対応するfieldを探す
                    const field = props.fields.find((f) => f.title === props.question.field_name);
                    if (field) {
                        form.field_ids = [field.id, null, null];
                    }
                }
                form.question = props.question.question;
                form.correct_answer = props.question.correct_answer;
                form.dummy_answer1 = props.question.dummy_answer1;
                form.dummy_answer2 = props.question.dummy_answer2;
                form.dummy_answer3 = props.question.dummy_answer3;
                form.dummy_answer4 = props.question.dummy_answer4;
                form.commentary = props.question.commentary;
                form.difficulty = props.question.difficulty ?? 0;
                form.tags = props.question.tags.map((tag) => tag.name);
                form.limit = props.limit;
                form.page = props.page;
            }
            form.subject_id = props.subject.id;
        });
        const refImageQuestion = ref();
        const refImageCommentary = ref();
        const onSubmitted = async () => {
            if (refImageQuestion.value) {
                form.imageQuestion = refImageQuestion.value?.files?.[0];
            }
            if (refImageCommentary.value) {
                form.imageCommentary = refImageCommentary.value?.files?.[0];
            }
            // field_idsからnullを除外してクリーンアップ
            const cleanFieldIds = form.field_ids.filter((id) => id !== null && id !== '');
            form.field_ids = cleanFieldIds;
            form.examinations = props.question.id ? [] : selectedExaminations.value;
            if (props.question.id) {
                const params = {
                    subject: props.subject,
                    question: props.question,
                };
                await form.post(route('questions.update', params));
            }
            else {
                const params = {
                    subject: props.subject,
                };
                await form.post(route('questions.store', params));
            }
        };
        const imageQuestionPreview = ref(null);
        const imageCommentaryPreview = ref(null);
        const openFileView = (event) => {
            const { target } = event;
            if (target.name === 'image_url_question') {
                refImageQuestion?.value?.click();
            }
            if (target.name === 'image_url_commentary') {
                refImageCommentary?.value?.click();
            }
        };
        const onFileChanged = (name) => {
            const reader = new FileReader();
            if (name === 'image_url_question') {
                reader.onload = (e) => {
                    imageQuestionPreview.value = e.target.result;
                };
                reader.readAsDataURL(refImageQuestion?.value?.files?.[0]);
            }
            if (name === 'image_url_commentary') {
                reader.onload = (e) => {
                    imageCommentaryPreview.value = e.target.result;
                };
                reader.readAsDataURL(refImageCommentary?.value?.files?.[0]);
            }
        };
        const onReturnClicked = () => {
            if (props.flash?.success === '追加しました。' && props.question.id) {
                Inertia.get(route('questions', {
                    subject: props.subject.id,
                }), {
                    page: props.page || '1',
                    limit: props.limit || '15',
                });
                return;
            }
            window.history.back();
        };
        const onDeletionButtonClicked = async () => {
            const params = {
                subject: props.subject,
                question: props.question,
            };
            await form.delete(route('questions.destroy', params));
        };
        const onOpenAddExaminationModal = () => {
            if (!selectedExaminationYear.value) {
                selectedExaminationYear.value = availableExaminationYears.value[0]
                    ? String(availableExaminationYears.value[0])
                    : '';
            }
            modalSelectedExaminations.value = props.question.id
                ? []
                : selectedExaminations.value.map((item) => ({ ...item }));
            showAddExaminationModal.value = true;
        };
        const onCloseAddExaminationModal = () => {
            showAddExaminationModal.value = false;
            modalSelectedExaminations.value = [];
        };
        const onClearModalSelectedExaminations = () => {
            modalSelectedExaminations.value = [];
        };
        const getSelectedExaminationType = (examinationId) => {
            const selected = modalSelectedExaminations.value.find((item) => item.id === examinationId);
            return selected?.type ?? null;
        };
        const onExaminationTypeChanged = (examinationId, type) => {
            const index = modalSelectedExaminations.value.findIndex((item) => item.id === examinationId);
            if (index > -1) {
                modalSelectedExaminations.value.splice(index, 1, {
                    id: examinationId,
                    type,
                });
                return;
            }
            modalSelectedExaminations.value.push({
                id: examinationId,
                type,
            });
        };
        const isLimitQuestionCount = (examinationId, type) => {
            const examinationQuestion = props.countExaminationQuestions.find((item) => Number(item.examination_id) === examinationId && Number(item.examination_type) === Number(type));
            if (!examinationQuestion) {
                return false;
            }
            const maxQuestionCount = Number(props.examinationTypesMaxQuestionCount[type]);
            if (!maxQuestionCount) {
                return false;
            }
            return !(Number(examinationQuestion.question_count) < maxQuestionCount);
        };
        const onAddExaminationClicked = () => {
            if (!props.question.id) {
                selectedExaminations.value = modalSelectedExaminations.value.map((item) => ({ ...item }));
                onCloseAddExaminationModal();
                return;
            }
            if (!modalSelectedExaminations.value.length) {
                return;
            }
            const examinations = modalSelectedExaminations.value.map((item) => ({ ...item }));
            showAddExaminationModal.value = false;
            const payload = {
                questions: [props.question.id],
                examinations,
                questionId: props.question.id,
                page: props.page,
                limit: props.limit,
            };
            modalSelectedExaminations.value = [];
            Inertia.post(route('questions.addExamination', { subject: props.subject.id }), payload);
        };
        const getExaminationKey = (examinationId, examinationType) => `${examinationId}-${examinationType}`;
        const isRemovingExamination = (examinationId, examinationType) => (removingExaminationKey.value === getExaminationKey(examinationId, examinationType));
        const isStartedByStartDate = (startDate) => {
            if (!startDate) {
                return false;
            }
            const parsedStartDate = new Date(startDate);
            if (Number.isNaN(parsedStartDate.getTime())) {
                return false;
            }
            return new Date() > parsedStartDate;
        };
        const isExaminationStarted = (examination) => isStartedByStartDate(examination?.start_date);
        const onRemoveExaminationClicked = (examinationId, examinationTitle, examinationType, startDate) => {
            if (!props.question.id) {
                return;
            }
            if (isStartedByStartDate(startDate)) {
                return;
            }
            // eslint-disable-next-line no-alert
            const isConfirmed = window.confirm(`「${examinationTitle}（${examinationTypeText(examinationType)}問題）」の連携を解除してもよろしいですか？`);
            if (!isConfirmed) {
                return;
            }
            removingExaminationKey.value = getExaminationKey(examinationId, examinationType);
            Inertia.delete(route('questions.removeExamination', {
                subject: props.subject.id,
                questionId: props.question.id,
                examinationId,
                examinationType,
                page: props.page,
                limit: props.limit,
            }), {
                onFinish: () => {
                    removingExaminationKey.value = '';
                },
            });
        };
        const onTagChanged = (result) => {
            form.tags = result;
        };
        const hasImageQuestion = computed(() => imageQuestionPreview.value || props.question.image_url_question);
        const hasImageCommentary = computed(() => imageCommentaryPreview.value || props.question.image_url_commentary);
        const targetDeleteImageUrl = ref('');
        const targetDeleteImageEvent = ref();
        const targetPreviewImageName = ref('');
        const confirmImagePreview = computed(() => {
            if (targetPreviewImageName.value === 'image_path_question') {
                return props.question.image_url_question;
            }
            if (targetPreviewImageName.value === 'image_path_commentary') {
                return props.question.image_url_commentary;
            }
            return '';
        });
        const onConfirmImageButtonClicked = (url, name, event) => {
            targetPreviewImageName.value = name;
            targetDeleteImageUrl.value = url;
            targetDeleteImageEvent.value = event;
            show.value = true;
        };
        const onDeleteImageButtonClicked = () => {
            const image = targetDeleteImageUrl.value.replace('/storage/', '');
            Inertia.delete(route('delete.question.image', {
                image,
                subjectId: props.subject.id,
                questionId: props.question.id,
                targetImagePath: targetPreviewImageName.value,
            }));
            show.value = false;
            targetPreviewImageName.value = '';
            targetDeleteImageUrl.value = '';
            targetDeleteImageEvent.value = '';
            form.image = '';
        };
        const onDeleteImageCanceled = () => {
            show.value = !show.value;
            targetPreviewImageName.value = '';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppLayout, _mergeProps(_unref(flashObject), { title: "QuestionShow" }), {
                header: _withCtx(() => [
                    _hoisted_1
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, _toDisplayString(props.question.id), 1)
                            ]),
                            (props.question.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _hoisted_8,
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["inline-flex rounded-full px-3 py-1 text-sm font-medium", props.question.is_available_in_app
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-gray-100 text-gray-700'])
                                        }, _toDisplayString(props.question.is_available_in_app ? '配信中' : '未配信'), 3)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", null, [
                                        _hoisted_13,
                                        _withDirectives(_createElementVNode("select", {
                                            id: "field_ids_0",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).field_ids[0]) = $event)),
                                            class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.field_ids }]),
                                            required: ""
                                        }, [
                                            _hoisted_14,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: field.id,
                                                    value: field.id
                                                }, _toDisplayString(field.title), 9, _hoisted_15));
                                            }), 128))
                                        ], 2), [
                                            [_vModelSelect, _unref(form).field_ids[0]]
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _hoisted_16,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).field_ids[1]) = $event)),
                                            class: "w-full rounded border-gray-400",
                                            disabled: !_unref(form).field_ids[0]
                                        }, [
                                            _hoisted_18,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFieldsForSecond), (field) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: field.id,
                                                    value: field.id
                                                }, _toDisplayString(field.title), 9, _hoisted_19));
                                            }), 128))
                                        ], 8, _hoisted_17), [
                                            [_vModelSelect, _unref(form).field_ids[1]]
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _hoisted_20,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).field_ids[2]) = $event)),
                                            class: "w-full rounded border-gray-400",
                                            disabled: !_unref(form).field_ids[1]
                                        }, [
                                            _hoisted_22,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFieldsForThird), (field) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: field.id,
                                                    value: field.id
                                                }, _toDisplayString(field.title), 9, _hoisted_23));
                                            }), 128))
                                        ], 8, _hoisted_21), [
                                            [_vModelSelect, _unref(form).field_ids[2]]
                                        ])
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.field_ids,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("input", {
                                        ref: (_value, _refs) => {
                                            _refs['refImageQuestion'] = _value;
                                            refImageQuestion.value = _value;
                                        },
                                        type: "file",
                                        accept: ".jpeg, .jpg, .png",
                                        class: "hidden",
                                        onChange: _cache[3] || (_cache[3] = ($event) => (onFileChanged('image_url_question')))
                                    }, null, 544),
                                    (_unref(hasImageQuestion))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            (__props.question.image_url_question)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "delete-button",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (onConfirmImageButtonClicked(__props.question.image_url_question, 'image_path_question', $event)))
                                                }, " × "))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                src: imageQuestionPreview.value ?? __props.question.image_url_question
                                            }, null, 8, _hoisted_28)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        class: "px-4 py-2 rounded bg-blue-600 text-xs text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                        name: "image_url_question",
                                        onClick: _withModifiers(openFileView, ["prevent"])
                                    }, " 画像追加 ", 8, _hoisted_29),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.image,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("div", _hoisted_32, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "question",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).question) = $event)),
                                        class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.question }]),
                                        rows: "10"
                                    }, "\n            ", 2), [
                                        [_vModelText, _unref(form).question]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.question,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("div", _hoisted_35, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "correct_answer",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).correct_answer) = $event)),
                                        type: "text",
                                        class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.correct_answer }])
                                    }, null, 2), [
                                        [_vModelText, _unref(form).correct_answer]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.correct_answer,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (index) => {
                                return _createElementVNode("div", {
                                    key: `answer-${index}`,
                                    class: "grid grid-cols-12 mt-4"
                                }, [
                                    _createElementVNode("label", {
                                        class: "col-span-2 pt-2 pr-4 text-right",
                                        for: `dummy_answer${index}`
                                    }, " 誤答" + _toDisplayString(index), 9, _hoisted_36),
                                    _createElementVNode("div", _hoisted_37, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: `dummy_answer${index}`,
                                            "onUpdate:modelValue": ($event) => ((_unref(form)[`dummy_answer${index}`]) = $event),
                                            type: "text",
                                            class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors[`dummy_answer${index}`] }])
                                        }, null, 10, _hoisted_38), [
                                            [_vModelText, _unref(form)[`dummy_answer${index}`]]
                                        ]),
                                        _createVNode(InputError, {
                                            message: _unref(form).errors[`dummy_answer${index}`],
                                            class: "mt-2"
                                        }, null, 8, ["message"])
                                    ])
                                ]);
                            }), 64)),
                            _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("input", {
                                        ref: (_value, _refs) => {
                                            _refs['refImageCommentary'] = _value;
                                            refImageCommentary.value = _value;
                                        },
                                        type: "file",
                                        accept: ".jpeg, .jpg, .png",
                                        class: "hidden",
                                        onChange: _cache[7] || (_cache[7] = ($event) => (onFileChanged('image_url_commentary')))
                                    }, null, 544),
                                    (_unref(hasImageCommentary))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                            (__props.question.image_url_commentary)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "delete-button",
                                                    onClick: _cache[8] || (_cache[8] = ($event) => (onConfirmImageButtonClicked(__props.question.image_url_commentary, 'image_path_commentary', $event)))
                                                }, " × "))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                src: imageCommentaryPreview.value ?? __props.question.image_url_commentary
                                            }, null, 8, _hoisted_43)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        class: "px-4 py-2 rounded bg-blue-600 text-xs text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                        name: "image_url_commentary",
                                        onClick: _withModifiers(openFileView, ["prevent"])
                                    }, " 画像追加 ", 8, _hoisted_44),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.image,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _createElementVNode("div", _hoisted_47, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "commentary",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(form).commentary) = $event)),
                                        class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.commentary }]),
                                        rows: "10"
                                    }, "\n            ", 2), [
                                        [_vModelText, _unref(form).commentary]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.commentary,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                                _hoisted_49,
                                _createElementVNode("div", _hoisted_50, [
                                    _withDirectives(_createElementVNode("select", {
                                        id: "difficulty",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(form).difficulty) = $event)),
                                        class: _normalizeClass({ 'bg-red-100': !!_unref(form).errors.difficulty })
                                    }, [
                                        _hoisted_51,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.difficulties, (difficulty, i) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: difficulty.id,
                                                value: i + 1
                                            }, _toDisplayString(difficulty.name), 9, _hoisted_52));
                                        }), 128))
                                    ], 2), [
                                        [_vModelSelect, _unref(form).difficulty]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.difficulty,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                                _hoisted_54,
                                _createElementVNode("div", _hoisted_55, [
                                    _createVNode(_unref(SmartTagz), {
                                        autosuggest: "",
                                        editable: "",
                                        "quick-delete": false,
                                        "input-placeholder": "入力してEnterキーで追加",
                                        sources: __props.allTags,
                                        "allow-paste": { delimiter: ',' },
                                        "allow-duplicates": false,
                                        "max-tags": 20,
                                        "default-tags": _unref(form).tags,
                                        "on-changed": onTagChanged
                                    }, null, 8, ["sources", "default-tags"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "px-6 py-2 rounded bg-green-500 text-white max-w-max shadow-sm hover:shadow-lg",
                                            onClick: onOpenAddExaminationModal
                                        }, _toDisplayString(__props.question.id ? '模試へ追加' : '追加先模試を選択'), 1)
                                    ]),
                                    (__props.question.id)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _hoisted_60,
                                            (Array.isArray(__props.question.examinations) &&
                                                __props.question.examinations.length)
                                                ? (_openBlock(), _createElementBlock("ul", _hoisted_61, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.examinations, (item, index) => {
                                                        return (_openBlock(), _createElementBlock("li", {
                                                            key: `${item.id}-${item.pivot.examination_type ?? index}`,
                                                            class: "pt-2"
                                                        }, [
                                                            _createElementVNode("div", _hoisted_62, [
                                                                _createElementVNode("span", _hoisted_63, _toDisplayString(item.title), 1),
                                                                (item.pivot.examination_type)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(examinationTypeText(item.pivot.examination_type)) + "問題 ", 1))
                                                                    : _createCommentVNode("", true),
                                                                (item.pivot.examination_type)
                                                                    ? (_openBlock(), _createElementBlock("button", {
                                                                        key: 1,
                                                                        type: "button",
                                                                        disabled: isRemovingExamination(item.id, item.pivot.examination_type) ||
                                                                            isExaminationStarted(item),
                                                                        class: _normalizeClass([
                                                                            isRemovingExamination(item.id, item.pivot.examination_type) || isExaminationStarted(item)
                                                                                ? 'opacity-50 cursor-not-allowed'
                                                                                : 'hover:bg-red-50',
                                                                            'shrink-0 px-3 py-1 text-xs rounded border border-red-500 text-red-600 bg-white',
                                                                        ]),
                                                                        onClick: ($event) => (onRemoveExaminationClicked(item.id, item.title, item.pivot.examination_type, item.start_date))
                                                                    }, " 模試連携解除 ", 10, _hoisted_65))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ]));
                                                    }), 128))
                                                ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_66, " この問題は模試に追加されていません。 "))
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _hoisted_67,
                                            (_unref(selectedExaminationSummaries).length)
                                                ? (_openBlock(), _createElementBlock("ul", _hoisted_68, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedExaminationSummaries), (item) => {
                                                        return (_openBlock(), _createElementBlock("li", {
                                                            key: `${item.id}-${item.type}`,
                                                            class: "pt-2"
                                                        }, [
                                                            _createElementVNode("div", _hoisted_69, [
                                                                _createElementVNode("span", _hoisted_70, _toDisplayString(item.title), 1),
                                                                _createElementVNode("span", _hoisted_71, _toDisplayString(examinationTypeText(item.type)) + "問題 ", 1)
                                                            ])
                                                        ]));
                                                    }), 128))
                                                ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_72, " まだ模試が選択されていません。 ")),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(examinationErrorMessages), (errorMessage, index) => {
                                                return (_openBlock(), _createBlock(InputError, {
                                                    key: `${index}-${errorMessage}`,
                                                    message: errorMessage,
                                                    class: "mt-2"
                                                }, null, 8, ["message"]));
                                            }), 128))
                                        ], 64))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded border border-blue-600 text-blue-600 max-w-max shadow-sm hover:shadow-lg"]),
                                disabled: _unref(form).processing,
                                onClick: onReturnClicked
                            }, " 戻る ", 10, _hoisted_74),
                            _hoisted_75,
                            _createElementVNode("button", {
                                class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                disabled: _unref(form).processing,
                                onClick: _withModifiers(onSubmitted, ["prevent"])
                            }, " 保存する ", 10, _hoisted_76)
                        ]),
                        (__props.question.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                _createElementVNode("button", {
                                    class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-red-700 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                    disabled: _unref(form).processing,
                                    onClick: _withModifiers(onDeletionButtonClicked, ["prevent"])
                                }, " 削除する ", 10, _hoisted_78)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createVNode(DialogModal, {
                        show: show.value,
                        "max-width": "lg",
                        onClose: onDeleteImageCanceled
                    }, {
                        title: _withCtx(() => [
                            _hoisted_79
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("img", {
                                    src: _unref(confirmImagePreview),
                                    class: "mx-auto h-64 w-96 object-cover"
                                }, null, 8, _hoisted_81)
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createVNode(WhiteButton, {
                                class: "mr-4 bg-white text-black",
                                onClick: onDeleteImageCanceled
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_82
                                ]),
                                _: 1
                            }),
                            _createElementVNode("button", {
                                class: "px-8 py-2 bg-red-600 text-red-50 rounded max-w-max shadow-sm hover:shadow-lg",
                                onClick: onDeleteImageButtonClicked
                            }, " 削除 ")
                        ]),
                        _: 1
                    }, 8, ["show"]),
                    _createVNode(DialogModal, {
                        show: showAddExaminationModal.value,
                        "max-width": "lg",
                        onClose: onCloseAddExaminationModal
                    }, {
                        title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_83, [
                                _createElementVNode("span", null, _toDisplayString(__props.question.id ? 'この問題を模試に追加する' : '保存時に追加する模試を選択する'), 1),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedExaminationYear).value = $event)),
                                    class: "rounded border-gray-400 text-sm"
                                }, [
                                    _hoisted_84,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableExaminationYears), (year) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: year,
                                            value: String(year)
                                        }, _toDisplayString(year) + "年度 ", 9, _hoisted_85));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, selectedExaminationYear.value]
                                ])
                            ])
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_86, [
                                (!__props.examinations.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_87, " 追加可能な模試がありません。 "))
                                    : (!_unref(filteredExaminations).length)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_88, " 選択した年度の模試がありません。 "))
                                        : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredExaminations), (examination, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: examination.id,
                                        class: "w-full p-3 mb-3 border border-gray-200 rounded"
                                    }, [
                                        _createElementVNode("div", _hoisted_89, _toDisplayString(examination.title), 1),
                                        _createElementVNode("div", _hoisted_90, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.examinationTypes, (type, key) => {
                                                return (_openBlock(), _createElementBlock("label", {
                                                    key: `${examination.id}-${key}`,
                                                    class: "inline-flex items-center mr-4 mb-2"
                                                }, [
                                                    _createElementVNode("input", {
                                                        checked: getSelectedExaminationType(examination.id) === Number(key),
                                                        disabled: isLimitQuestionCount(examination.id, Number(key)),
                                                        type: "radio",
                                                        name: `examination-type-${index}`,
                                                        class: "form-radio mr-1",
                                                        onChange: ($event) => (onExaminationTypeChanged(examination.id, Number(key)))
                                                    }, null, 40, _hoisted_91),
                                                    _createElementVNode("span", null, _toDisplayString(type), 1),
                                                    (isLimitQuestionCount(examination.id, Number(key)))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_92, " (上限) "))
                                                        : _createCommentVNode("", true)
                                                ]));
                                            }), 128))
                                        ])
                                    ]));
                                }), 128))
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createElementVNode("div", _hoisted_93, [
                                _createVNode(WhiteButton, {
                                    class: "bg-white text-black whitespace-nowrap shrink-0",
                                    onClick: onCloseAddExaminationModal
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_94
                                    ]),
                                    _: 1
                                }),
                                (!__props.question.id)
                                    ? (_openBlock(), _createBlock(WhiteButton, {
                                        key: 0,
                                        class: "bg-white text-black whitespace-nowrap shrink-0",
                                        onClick: onClearModalSelectedExaminations
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_95
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                    disabled: _unref(isAddExaminationButtonDisabled),
                                    class: _normalizeClass([[_unref(isAddExaminationButtonDisabled) ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-blue-600 text-blue-50'], "px-8 py-2 rounded max-w-max shadow-sm hover:shadow-lg whitespace-nowrap shrink-0"]),
                                    onClick: onAddExaminationClicked
                                }, _toDisplayString(__props.question.id ? '追加' : '選択を保存'), 11, _hoisted_96)
                            ])
                        ]),
                        _: 1
                    }, 8, ["show"])
                ]),
                _: 1
            }, 16));
        };
    }
});
